import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      checkboxIcon: '$deepBlue11',
      checkboxBg: 'transparent',
      checkboxBorder: '$slate8',
      checkboxCheckedBg: '$primary',
      checkboxCheckedIcon: 'white',
      checkboxCheckedHoverBg: tinycolor(primaryColor.value).darken().toHslString(),
      checkboxHoverBg: 'transparent',
      checkboxHoverBorder: '$primary',
      checkboxFocusBorder: '$primary',
      checkboxDisabledBg: '$deepBlue3',
      checkboxDisabledBorder: '$deepBlue5',
      checkboxIndicatorDisabledBg: tinycolor(primaryColor.value).setAlpha(0.6).toHslString()
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      checkboxIcon: '$deepBlue1',
      checkboxBg: 'transparent',
      checkboxCheckedBg: '$primary',
      checkboxBorder: '$slate9',
      checkboxCheckedIcon: '$deepBlue1',
      checkboxCheckedHoverBg: tinycolor(primaryColor.value).lighten(10).toHslString(),
      checkboxHoverBg: '$deepBlue3',
      checkboxHoverBorder: '$primary',
      checkboxFocusBorder: '$primary',
      checkboxDisabledBg: tinycolor(primaryColor.value).setAlpha(0.6).toHslString(),
      checkboxDisabledBorder: 'transparent',
      checkboxIndicatorDisabledBg: '$deepBlue1'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
